import { Progress, Form } from 'antd';
import { useState, useEffect } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import DSRequestFormService from '../../../services/DSRequestForm.service';
import GlobalService from '../../../services/Global.service';
import StepWizard from 'react-step-wizard';
// import icon from './logo_wf.svg';

//Step Form
import Step1 from './Stap1';
import Step2 from './Stap2';
import Step3 from './Stap3';
import Step4 from './Stap4';
import Step5 from './Stap5';
import moment from 'moment';
const { Provider } = Form;

const DsFormStep = () => {
    const navigate = useNavigate();
    const { lang: lang_, domainId } = useParams();
    /// useState
    //Customize
    const lang = lang_?.toUpperCase();

    const [customForm, setCustomForm] = useState();
    const [customStyle, setCustomStyle] = useState();
    const [fontStyle, setFontStyle] = useState();
    const [logo, setLogo] = useState();
    const [icon, setIcon] = useState();
    //List
    const [personalTypeList, setPersonalTypeList] = useState([]);
    const [detailOfClaim, setDetailOfClaim] = useState();
    const [proofOfIdentity, setProofOfIdentity] = useState();
    const [currentProgress, setCurrentProgress] = useState(0);
    const [state, updateState] = useState();

    const [submitData, setSubmitData] = useState({});
    const [imageFile, setImageFile] = useState([]);
    const [docFile, setDocFile] = useState([]);
    // form
    const [applicantInformation] = Form.useForm();
    const [personalInformation] = Form.useForm();
    const [detailsOfClaim] = Form.useForm();
    const [evidenceInformation] = Form.useForm();
    const [disbleUpload, setDisbleUpload] = useState(false);

    const calProgress = (number) => {
        setCurrentProgress(number);
    };

    const getPersonalType = async (values, companyId) => {
        const item = [];
        values?.dataSubjectType?.forEach((element) => {
            if (element?.isUsed) {
                item?.push(element);
            }
        });
        // setPersonalTypeList(values?.dataSubjectType);
        setPersonalTypeList(item);
    };

    const getImage = async (logoId) => {
        try {
            const { data } = await GlobalService.getImageNoSecure(logoId);
            if (data.resultData?.imageId) {
                setIcon(`data:image/png;base64,${data.resultData?.imageId}`);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const setInstance = (SW) =>
        updateState({
            ...state,
            SW,
        });

    const [loadingForm, setLoadingForm] = useState(false);

    const onFormFinish = async () => {
        setLoadingForm(true);

        const evidenceInformation_ = evidenceInformation.getFieldsValue();
        const applicantInformation_ = applicantInformation.getFieldsValue();
        const dataSubjectInformation = personalInformation.getFieldsValue();
        const detailsOfClaim_ = detailsOfClaim.getFieldsValue();

        const payload = {
            applicantInformation: { ...applicantInformation_ },
            detailsOfClaim: { ...detailsOfClaim_ },
            dataSubjectInformation: {
                ...dataSubjectInformation,
            },
            evidenceInformation: {
                ...evidenceInformation_,
                evidence: disbleUpload,
                filesDoc: docFile,
                filesImage: imageFile,
            },
            domainId: domainId,
            comfirmation: true,
        };

        try {
            const { data } = await DSRequestFormService.submitForm(payload);
            if (data?.resultCode === 1) {
                setLoadingForm(false);
                navigate(`/thank-you-page/${lang}`, { state: { domainId } });
            } else {
                setLoadingForm(false);
                console.log(data);
            }
        } catch (error) {
            setLoadingForm(false);
            console.log(error);
        }
    };

    const [allCustom, setallCustom] = useState();
    const getCustomForm = async () => {
        try {
            const { data } = await DSRequestFormService.getPublicCustomize(
                domainId
            );
            const item = data?.resultData;
            document.body.style.backgroundColor =
                item?.customizeStyle?.mainColor;
            setallCustom(item);
            setCustomForm(item?.customizeForm);
            setCustomStyle({
                ...item?.customizeStyle,
                buttonColor: item?.customizeStyle?.buttonColor,
            });
            setFontStyle(item?.fontStyle);
            setLogo(item?.logo);
            getImage(item?.logo?.companyLogoId);
            // getDomain(item);
            getPersonalType(item?.customizeForm);
        } catch (error) {
            console.log(error);
        }
    };

    const getMasterDsRequuestForm = async (items) => {
        const { data } = await DSRequestFormService.getMasterDsRequuestForm(
            domainId
        );
        setDetailOfClaim(data?.resultData.detailsOfClaim);
        setProofOfIdentity(data?.resultData?.proofOfIdentity);
    };

    useEffect(() => {
        getCustomForm();
        getMasterDsRequuestForm();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const termAndPrivacy = (customForm, color) => {
        let URLID = customForm?.policyAndTermsOfService?.privacyPolicyUrlId;
        let URL1 = customForm?.policyAndTermsOfService?.termConditionUrl;
        let URL2 = URLID
            ? `${window.location.origin}/external-privacy?id=${URLID}`
            : customForm?.policyAndTermsOfService?.privacyPolicyUrl;
        if (URL1 && URL2) {
            return (
                <div
                    style={{
                        color: color,
                        textDecorationColor: color,
                    }}
                >
                    <button
                        type="button"
                        onClick={() => window.open(URL1)}
                        className="cursor-pointer underline decoration-solid decoration-1 underline-offset-2 duration-150 hover:opacity-50"
                    >
                        {'Term & Condition'}
                    </button>{' '}
                    &{' '}
                    <button
                        type="button"
                        onClick={() => window.open(URL2)}
                        className="cursor-pointer underline decoration-solid decoration-1 underline-offset-2 duration-150 hover:opacity-50"
                        style={{
                            color: color,
                            textDecorationColor: color,
                        }}
                    >
                        {'Privacy Policy'}
                    </button>
                </div>
            );
        } else if (URL1) {
            return (
                <div
                    style={{
                        color: color,
                        textDecorationColor: color,
                    }}
                >
                    <button
                        type="button"
                        onClick={() => window.open(URL1)}
                        className="cursor-pointer underline decoration-solid decoration-1 underline-offset-2 duration-150 hover:opacity-50"
                        style={{
                            color: color,
                            textDecorationColor: color,
                        }}
                    >
                        {'Term & Condition'}
                    </button>
                </div>
            );
        } else if (URL2) {
            return (
                <div
                    style={{
                        color: color,
                        textDecorationColor: color,
                    }}
                >
                    <button
                        type="button"
                        onClick={() => window.open(URL2)}
                        className="cursor-pointer underline decoration-solid decoration-1 underline-offset-2 duration-150 hover:opacity-50"
                        style={{
                            color: color,
                            textDecorationColor: color,
                        }}
                    >
                        {'Privacy Policy'}
                    </button>
                </div>
            );
        } else {
            return <></>;
        }
    };

    return (
        <div
            className="pt-8 pb-4"
            style={{
                fontFamily: `"Poppins", "${fontStyle?.fontFamily}", sans-serif`, //fontFamily
            }}
        >
            <div className=" mx-auto sm:w-[100%] md:w-[100%] lg:w-[80%] xl:w-[60%]">
                <div className="space-y-3 px-3 md:px-8">
                    <div
                        className="sm:grid sm:grid-cols-1 md:flex justify-between items-center"
                        style={{ color: fontStyle?.textTitleColor }}
                    >
                        <div className="sm:basis-full md:basis-4/6 text-xl font-bold">
                            Data Subject Rights Request Form
                        </div>
                        <div className="sm:basis-full md:basis-2/6 sm:text-left md:text-right text-xs font-medium">
                            {lang === 'TH' ? 'วันที่ส่งคำขอ' : 'Request Date'}{' '}
                            {moment(new Date()).format('DD/MM/YYYY')}
                        </div>
                    </div>
                    {/* Progress */}
                    {/* <div className="bg-white rounded-md p-4 grid sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4 sm:gap-1 md:gap-7 font-semibold text-base"> */}
                    <div className="bg-white rounded-md p-4 sm:grid sm:grid-cols-1 md:flex md:space-x-3 font-semibold text-base">
                        {/* <div className="-mt-0.5 md:col-span-2 lg:col-span-3"> */}
                        <div className="-mt-0.5 md:basis-7/12 lg:basis-6/12 xl:basis-7/12 2xl:basis-8/12 ">
                            <Progress
                                strokeColor={{
                                    '0%': '#4ACE8F',
                                    '100%': '#4ACE8F',
                                }}
                                percent={currentProgress}
                                status="active"
                                showInfo={false}
                            />
                        </div>
                        {/* <div className="col-span-1"> */}
                        <div className="md:basis-5/12 lg:basis-6/12 xl:basis-5/12 2xl:basis-4/12 ">
                            <span
                                className={`pr-2 ${
                                    currentProgress === 0
                                        ? 'text-red-500'
                                        : 'text-green-400'
                                }`}
                            >
                                {currentProgress}%{' '}
                                {lang === 'TH' ? 'สำเร็จ' : 'Succeed'}
                            </span>

                            <span className="sm:text-left md:text-right">
                                {lang === 'TH'
                                    ? 'คุณกรอกข้อมูลเรียบร้อยแล้ว'
                                    : 'Filled Information'}
                            </span>
                        </div>
                    </div>
                    {/* DS Request Form */}
                    <Provider onFormFinish={onFormFinish}>
                        <StepWizard instance={setInstance} transitions>
                            <Step1
                                lang={lang}
                                loading={false}
                                form={applicantInformation}
                                personalInformation={personalInformation}
                                calProgress={calProgress}
                                customForm={customForm}
                                customStyle={customStyle}
                                fontStyle={fontStyle}
                                getPersonalType={() =>
                                    getPersonalType(allCustom?.customizeForm)
                                }
                            />
                            <Step2
                                lang={lang}
                                loading={false}
                                form={personalInformation}
                                formStep1={applicantInformation}
                                currentProgress={currentProgress}
                                calProgress={calProgress}
                                customForm={customForm}
                                customStyle={customStyle}
                                fontStyle={fontStyle}
                                personalTypeList={personalTypeList}
                            />
                            <Step3
                                lang={lang}
                                loading={false}
                                form={detailsOfClaim}
                                calProgress={calProgress}
                                customForm={customForm}
                                customStyle={customStyle}
                                fontStyle={fontStyle}
                                detailOfClaim={detailOfClaim}
                                rightDescriptionList={
                                    allCustom?.rightDescriptionList
                                }
                            />
                            <Step4
                                lang={lang}
                                loading={false}
                                form={evidenceInformation}
                                calProgress={calProgress}
                                customForm={customForm}
                                customStyle={customStyle}
                                fontStyle={fontStyle}
                                proofOfIdentity={proofOfIdentity}
                                disbleUpload={disbleUpload}
                                setDisbleUpload={setDisbleUpload}
                                imageFile={imageFile}
                                setImageFile={setImageFile}
                                docFile={docFile}
                                setDocFile={setDocFile}
                            />
                            <Step5
                                lang={lang}
                                step1={applicantInformation}
                                step2={personalInformation}
                                step3={detailsOfClaim}
                                step4={evidenceInformation}
                                loading={false}
                                calProgress={calProgress}
                                onFormFinish={onFormFinish}
                                data={submitData}
                                customForm={customForm}
                                customStyle={customStyle}
                                fontStyle={fontStyle}
                                loadingForm={loadingForm}
                            />
                        </StepWizard>
                    </Provider>

                    {/* url logo */}
                    <div className="flex justify-between">
                        <div>
                            {termAndPrivacy(
                                customForm,
                                fontStyle?.textLinkColor
                            )}
                        </div>
                        <div>
                            {/* <div className="flex items-center">
                        </div> */}
                            {logo?.hiddenLogo && (
                                <img alt="logo" width={20} src={icon} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DsFormStep;
